import { Exclude, Expose, Type } from 'class-transformer';
import { BaseModel } from '../models';

export type PageMargin = {
  left: number | string;
  top: number | string;
  right: number | string;
  bottom: number | string;
};

@Exclude()
export class DocConverterPrintOption {
  @Expose()
  margin!: PageMargin;

  @Expose()
  headerTemplate?: string;

  @Expose()
  footerTemplate?: string;

  @Expose()
  displayHeaderFooter?: boolean;

  @Expose()
  password?: string;
}

@Exclude()
export class DocConverterHtml2PdfDto extends BaseModel {
  @Expose() html!: string;

  @Expose()
  @Type(() => DocConverterPrintOption)
  printOptions!: DocConverterPrintOption;
}
